// Shift+click range selection for checkbox lists (bulk-edit tables).
//
//   import { enableRangeSelect } from "../components/range_select"
//   enableRangeSelect(".js-asset-check")
//
// Click one checkbox, then shift+click another: every checkbox between them
// (in document order) takes the second click's state. Disabled boxes are
// left alone — they can't be clicked, so a range sweep must not flip them
// either. Handlers are delegated, so re-rendered rows and turbolinks
// navigations need no rebinding, and each box the range flips gets a change
// event so count toolbars stay in sync.
export function enableRangeSelect(checkboxSelector) {
  var lastClicked = null

  // Shift+mousedown would otherwise start a text selection across the rows.
  $(document).on("mousedown", checkboxSelector, function (event) {
    if (event.shiftKey) event.preventDefault()
  })

  $(document).on("click", checkboxSelector, function (event) {
    if (event.shiftKey && lastClicked && lastClicked !== this) {
      var boxes = $(checkboxSelector).toArray()
      var from = boxes.indexOf(lastClicked)
      var to = boxes.indexOf(this)
      // from is -1 when the anchor's row was re-rendered or removed after the
      // click that set it — fall through so this click becomes the new anchor.
      if (from !== -1 && to !== -1) {
        // The clicked box has already toggled, so it defines the range state
        // and skips itself in the loop (its checked already matches).
        var state = this.checked
        boxes
          .slice(Math.min(from, to), Math.max(from, to) + 1)
          .forEach(function (box) {
            if (!box.disabled && box.checked !== state) {
              box.checked = state
              $(box).trigger("change")
            }
          })
      }
    }
    lastClicked = this
  })
}
